module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hero_600.a2befc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/job-description-generator/fullscreen-image_hero_600.png
// module id = ogQu
// module chunks = 0